import { PropsWithChildren } from 'react';

import { Td } from '../../summary/components/Td.tsx';
import { Tr } from '../../summary/components/Tr.tsx';
import { Typography } from '../../summary/components/Typography.tsx';
import { SummaryTable } from './SummaryTable.js';
import { SummaryTableHorizontalPropertyRows } from './SummaryTableHorizontalPropertyRows.tsx';
import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2 } from './types.ts';
import { getColumnHeaders } from './utils/getColumnHeaders.ts';
import { getTableData } from './utils/getTableData.ts';

export const SummaryTableHorizontal = ({
  compSequence,
  summary,
  columns,
  tableData,
  subjectHeader = 'Subject',
  compHeaderPrefix = 'Comp ',
}: PropsWithChildren<{
  compSequence: string[];
  summary: Tkv2PairedCostSummaryInterfaceV2;
  columns: BreakdownColumn[];
  tableData?: { [id: string]: unknown[] };
  subjectHeader?: string;
  compHeaderPrefix?: string;
}>) => {
  const data = tableData ?? getTableData(columns, summary, compSequence);

  return (
    <SummaryTable>
      <Tr>
        <Td border="0 !important" />
        {getColumnHeaders(columns).map((header) => {
          return (
            <Td key={`header-${header}`} border="0 !important">
              <Typography variant="h5">{header}</Typography>
            </Td>
          );
        })}
      </Tr>
      <SummaryTableHorizontalPropertyRows
        columns={columns}
        header={subjectHeader}
        tableDataRow={data.subject}
        summary={summary}
        isFirstRow
      />

      {compSequence.map((compId, idx) => {
        return (
          <SummaryTableHorizontalPropertyRows
            key={`comp-row-${compId}-${idx}`}
            columns={columns}
            header={`${compHeaderPrefix}${idx + 1}`}
            tableDataRow={data[compId]}
            summary={summary}
            compId={compId}
          />
        );
      })}
    </SummaryTable>
  );
};
